import KeyboardRenderer from "../keyboard-renderer";
import { RenderingStatus } from "./canvas-renderer";
export default class MenuRenderer extends KeyboardRenderer {
    reset(data) {
        super.reset(data);
        data.menuIndex = 0;
        delete data.selectedIndex;
    }
    performRendering(data, timestamp) {
        var _a, _b, _c;
        if ((_a = data.background) === null || _a === void 0 ? void 0 : _a.image) {
            (_b = this.context) === null || _b === void 0 ? void 0 : _b.drawImage((_c = data.background) === null || _c === void 0 ? void 0 : _c.image, 0, 0);
        }
        this.renderSlides(data, timestamp);
        return data.selectedIndex === undefined || data.message || data.subMenu ? RenderingStatus.RENDERING : RenderingStatus.COMPLETED;
    }
    createKeyHandlerDown(data) {
        var _a;
        const numOptions = (_a = data.numOptions) !== null && _a !== void 0 ? _a : 2;
        return (e) => {
            var _a, _b, _c, _d;
            if (!data.message) {
                e.preventDefault();
                switch (e.code) {
                    case "KeyW":
                    case "ArrowUp":
                        data.menuIndex = (((_a = data.menuIndex) !== null && _a !== void 0 ? _a : 0) - 1 + numOptions) % numOptions;
                        break;
                    case "KeyS":
                    case "ArrowDown":
                        data.menuIndex = (((_b = data.menuIndex) !== null && _b !== void 0 ? _b : 0) + 1 + numOptions) % numOptions;
                        break;
                    case "Space":
                        data.selectedIndex = data.menuIndex;
                        this.unregisterListener();
                        this.performAction(data, (_c = data.actions) === null || _c === void 0 ? void 0 : _c[(_d = data.selectedIndex) !== null && _d !== void 0 ? _d : -1], { rand: Math.random() });
                        break;
                }
            }
        };
    }
}
